(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $535a97b118e73429$exports = {};

function $535a97b118e73429$var$shiftAndMerge(board, direction) {
    var transpose = function(matrix) {
        return matrix[0].map(function(_, i) {
            return matrix.map(function(row) {
                return row[i];
            });
        });
    };
    var reverse = function(matrix) {
        return matrix.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
        });
    };
    var rotate = {
        up: transpose,
        down: function(b) {
            return reverse(transpose(b));
        },
        left: function(b) {
            return b;
        },
        right: reverse
    };
    var unrotate = {
        up: transpose,
        down: function(b) {
            return transpose(reverse(b));
        },
        left: function(b) {
            return b;
        },
        right: reverse
    };
    var rotated = rotate[direction](board);
    var score = 0;
    var mergedBoard = rotated.map(function(row) {
        var _mergeRow = $535a97b118e73429$var$mergeRow(row), merged = _mergeRow.merged, mergeScore = _mergeRow.mergeScore;
        score += mergeScore;
        return merged;
    });
    return {
        board: unrotate[direction](mergedBoard),
        totalScore: score
    };
}
function $535a97b118e73429$var$mergeRow(row) {
    var filtered = row.filter(function(num) {
        return num !== 0;
    });
    var result = [];
    var score = 0;
    for(var i = 0; i < filtered.length; i++)if (filtered[i] === filtered[i + 1]) {
        var merged = filtered[i] * 2;
        result.push(merged);
        score += merged;
        i++;
    } else result.push(filtered[i]);
    while(result.length < 4)result.push(0);
    return {
        merged: result,
        mergeScore: score
    };
}
$535a97b118e73429$exports = {
    shiftAndMerge: $535a97b118e73429$var$shiftAndMerge
};


var $3d28d7f1aac198f5$require$shiftAndMerge = $535a97b118e73429$exports.shiftAndMerge;
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this.score = 0;
        this.status = "idle";
        this.hasWon = false;
        this.board = this.isValidBoard(initialState) ? initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        }) : this.createEmptyBoard();
        // Initial status check
        this.updateStatus();
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "createEmptyBoard",
            value: function createEmptyBoard() {
                var _this = this;
                return Array.from({
                    length: this.size
                }, function() {
                    return Array(_this.size).fill(0);
                });
            }
        },
        {
            key: "isValidBoard",
            value: function isValidBoard(board) {
                var _this = this;
                return Array.isArray(board) && board.length === this.size && board.every(function(row) {
                    return Array.isArray(row) && row.length === _this.size && row.every(function(cell) {
                        return Number.isInteger(cell) && cell >= 0;
                    });
                });
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.board = this.createEmptyBoard();
                this.score = 0;
                this.status = "playing";
                this.hasWon = false;
                this.spawnTile();
                this.spawnTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.start();
            }
        },
        {
            key: "handleMove",
            value: function handleMove(direction) {
                if (this.status !== "playing") return;
                var prevBoard = this.board;
                var _shiftAndMerge = $3d28d7f1aac198f5$require$shiftAndMerge(prevBoard, direction), newBoard = _shiftAndMerge.board, totalScore = _shiftAndMerge.totalScore;
                if (!this.boardsEqual(prevBoard, newBoard)) {
                    this.board = newBoard;
                    this.score += totalScore;
                    // Check for win before spawning a tile
                    if (!this.hasWon && this.board.flat().some(function(val) {
                        return val >= 2048;
                    })) {
                        this.hasWon = true;
                        this.status = "win";
                        return;
                    }
                    this.spawnTile();
                    this.updateStatus();
                }
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.handleMove("left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.handleMove("right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.handleMove("up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.handleMove("down");
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                var _this = this;
                return [
                    "up",
                    "down",
                    "left",
                    "right"
                ].some(function(dir) {
                    var _shiftAndMerge = $3d28d7f1aac198f5$require$shiftAndMerge(_this.board, dir), moved = _shiftAndMerge.board;
                    return !_this.boardsEqual(_this.board, moved);
                });
            }
        },
        {
            key: "spawnTile",
            value: function spawnTile() {
                if (this.status !== "playing") return;
                var emptyCells = [];
                for(var r = 0; r < this.size; r++){
                    for(var c = 0; c < this.size; c++)if (this.board[r][c] === 0) emptyCells.push([
                        r,
                        c
                    ]);
                }
                if (emptyCells.length === 0) return;
                var _emptyCells_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), row = _emptyCells_Math_floor[0], col = _emptyCells_Math_floor[1];
                this.board[row][col] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "boardsEqual",
            value: function boardsEqual(b1, b2) {
                return b1.every(function(row, r) {
                    return row.every(function(val, c) {
                        return val === b2[r][c];
                    });
                });
            }
        },
        {
            key: "updateStatus",
            value: function updateStatus() {
                if (this.hasWon) this.status = "win";
                else if (!this.canMove()) this.status = "lose";
                else if (this.status === "idle") this.status = "playing";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


document.addEventListener("DOMContentLoaded", function() {
    var game = new $3d28d7f1aac198f5$exports();
    var scoreEl = document.querySelector(".game-score");
    var startBtn = document.querySelector(".button.start");
    var startMessageEl = document.querySelector(".message-start");
    var winMessageEl = document.querySelector(".message-win");
    var loseMessageEl = document.querySelector(".message-lose");
    // Assign unique IDs to grid cells
    document.querySelectorAll(".field-row").forEach(function(row, rowIndex) {
        row.querySelectorAll(".field-cell").forEach(function(cell, colIndex) {
            cell.id = "cell-".concat(rowIndex, "-").concat(colIndex);
        });
    });
    var hasStarted = false;
    var updateBoard = function() {
        var board = game.getState();
        for(var r = 0; r < board.length; r++)for(var c = 0; c < board[r].length; c++){
            var cell = document.getElementById("cell-".concat(r, "-").concat(c));
            var val = board[r][c];
            var newClass = "field-cell ".concat(val === 0 ? "empty" : "field-cell--".concat(val));
            if (cell && (cell.className !== newClass || cell.textContent !== String(val || ""))) {
                cell.className = newClass;
                cell.textContent = val || "";
            }
        }
    };
    var updateScore = function() {
        scoreEl.textContent = game.getScore().toString();
    };
    var resetMessages = function() {
        startMessageEl.classList.add("hidden");
        winMessageEl.classList.add("hidden");
        loseMessageEl.classList.add("hidden");
    };
    var updateStartButton = function() {
        startBtn.textContent = "Restart";
        startBtn.classList.remove("start");
        startBtn.classList.add("restart");
    };
    var checkEndGame = function(gameStatus) {
        if (gameStatus === "win") winMessageEl.classList.remove("hidden");
        else if (gameStatus === "lose") loseMessageEl.classList.remove("hidden");
    };
    var processMove = function(direction) {
        if (!hasStarted) return;
        var gameStatus = game.getStatus();
        if (gameStatus === "playing") {
            game.handleMove(direction);
            updateBoard();
            updateScore();
            checkEndGame(game.getStatus());
        }
    };
    var keyToDirection = {
        ArrowLeft: "left",
        ArrowRight: "right",
        ArrowUp: "up",
        ArrowDown: "down"
    };
    document.addEventListener("keydown", function(e) {
        var direction = keyToDirection[e.code];
        if (direction) {
            e.preventDefault();
            processMove(direction);
        }
    });
    startBtn.addEventListener("click", function() {
        resetMessages();
        if (!hasStarted) {
            game.start();
            hasStarted = true;
            updateStartButton();
        } else {
            game.restart();
            resetMessages();
        }
        updateBoard();
        updateScore();
    });
    updateBoard();
    updateScore();
});

})();
//# sourceMappingURL=index.bae900cc.js.map
